import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';

export const ROUTES_USER: Routes = [
  { path: 'login', component: LoginComponent }
];
